import React from "react";
import {useParams} from "react-router-dom";
import {DocumentsList} from "../../../controls/vidence/documents/DocumentsList";
import {healingDocumentDataType} from "../../../../providers/definitions/HealingDefinitionProvider";

export default function ClassDocumentsTab() {
    const {id} = useParams();
    return (<DocumentsList ownerId={id} dataType={healingDocumentDataType}/>);
}
